import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCVKKuyIIEubWa_If2CrJVh_0YN4om5jls",
  authDomain: "fir-c6d7d.firebaseapp.com",
  projectId: "fir-c6d7d",
  storageBucket: "fir-c6d7d.appspot.com",
  messagingSenderId: "311395167935",
  appId: "1:311395167935:web:0a80486de6a46dac6de00a",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const provider = new GoogleAuthProvider();

export default app;
